var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container thank-you" }, [
    _vm.error
      ? _c("div", [_c("h2", [_vm._v(_vm._s(_vm.error.message) + ".")])])
      : _vm.paymentIntent && _vm.paymentIntent.status === "processing"
      ? _c("div", [_c("h2", [_vm._v("Payment needs to be confirmed.")])])
      : (_vm.paymentIntent && _vm.paymentIntent.status === "succeeded") ||
        !_vm.paymentIntent
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("h2", [_vm._v("Thank you for your purchase!")]),
          _vm._v(" "),
          _c("h3", [_vm._v("Your payment has been confirmed")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("A confirmation email will be sent to your email address")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button pink full-width payment-button",
              attrs: { type: "submit" },
              on: { click: _vm.goToHome }
            },
            [_vm._v("Return to the app")]
          )
        ])
      : _c("div", [_c("h2", [_vm._v("Your payment failed.")])])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "success-icon-wrapper" }, [
      _c("img", {
        staticClass: "success-icon",
        attrs: { src: "images/Check-2.svg" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29f961c3", { render: render, staticRenderFns: staticRenderFns })
  }
}